import {Directive, EventEmitter, HostBinding, HostListener, Input, OnInit, Output} from '@angular/core';

@Directive({
    selector: '[timeformat]',
    standalone: false
})
export class TimeFormatDirective implements OnInit {

  @Input() timeformat: string;
  @Output() timeformatChange: EventEmitter<any> = new EventEmitter<any>();

  @HostBinding('attr.value') get value(): string {
    return this.timeformat;
  }

  constructor() {
  }

  ngOnInit() {
    this.timeformat = this.timeformat || '';
    this.format({target: {value: this.timeformat}});
  }

  @HostListener('input', ['$event'])
  format($event) {
    if ($event.inputType === 'deleteContentBackward') {
      return;
    }

    let value = $event.target.value;
    const tmp = value.replace(/[^0-9]/g, '');
    if (tmp.length < 2) {
      value = tmp;
    } else if (tmp.length === 2) {
      value = (parseInt(tmp.substr(0, 2), 10) > 24 ? 24 : tmp.substr(0, 2)) + ':' + '00';
    } else if (tmp.length === 3) {
      value = tmp.substr(0, 2) + ':' + tmp.substr(-1);
    } else {
      value = tmp.substr(0, 2) + ':' + (parseInt(tmp.substr(-2), 10) > 59 ? '59' : tmp.substr(-2));
    }
    this.timeformatChange.next([value]);
  }
}
